import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import BaseComponent from "../components/Helpers";
import { NavLink } from 'react-router-dom';
import { logout } from '../actions/user';
import { ReactComponent as IconClose } from '../../img/icon-close.svg'

class Navigation extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { };
  }

  render() {
    
    return (
      <div className={this.props.open ? "nav active" : "nav" }>
        <div className="close" onClick={ this.props.close }><IconClose /></div>
        <div className="nav-links">
          <NavLink className="nav-item" exact to="/ranking" onClick={ this.props.close }><span>Ranking</span></NavLink>
          <NavLink className="nav-item" exact to="/statystyki" onClick={ this.props.close }><span>Moje statystyki</span></NavLink>
          <NavLink className="nav-item" exact to="/profil" onClick={ this.props.close }><span>Profil</span></NavLink>
          <NavLink className="nav-item" exact to="/wyplac" onClick={ this.props.close }><span>Wypłać</span></NavLink>

          <NavLink className="nav-item small" style={{ marginTop: "40px"}} exact to="/poznaj-nasze-urzadzenia" onClick={ this.props.close }><span>Poznaj produkty BAT</span></NavLink>
          <NavLink className="nav-item small" exact to="/skrot-info" onClick={ this.props.close }><span>Dodawanie skrótu</span></NavLink>
          <NavLink className="nav-item small" exact to="/kontakt" onClick={ this.props.close }><span>Kontakt</span></NavLink>
          <NavLink className="nav-item small" exact to="/faq" onClick={ this.props.close }><span>FAQ</span></NavLink>
          <NavLink className="nav-item small" exact to="/regulamin" onClick={ this.props.close }><span>Regulaminy</span></NavLink>
        </div>
        <div className="nav-footer">
          <span className="nav-item" onClick={ () => { this.props.close(); this.props.logout(this.props.history) } }><span>Wyloguj</span></span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { screen, user } = state
  return { screen, user }
};

export default withRouter(connect(
  mapStateToProps,
  {
    logout
  }
)(Navigation));